import http from "../lib/http";

// Get all available promo codes
export const getPromoCodes = async () => {
  const response = await http.get("/api/customer/promo-codes");
  return response.data;
};

// Apply a promo code by ID
export const applyPromoCode = async (promocode_id) => {
  const response = await http.post("/api/customer/promo-codes/apply", {
    promocode_id,
  });
  return response.data;
};

// Get applied promo code(s)
export const getAppliedPromoCodes = async () => {
  const response = await http.get("/api/customer/promo-codes/applied");
  return response.data;
};
